import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-other-verification-methods',
  templateUrl: './other-verification-methods.component.html',
  styleUrls: ['./other-verification-methods.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OtherVerificationMethodsComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<OtherVerificationMethodsComponent>,
  ) { }

  ngOnInit() { }

  selectMethod(method: string) {
    this.dialogRef.close(method);
  }
}
